import { ShieldCheck, ArrowRight, CheckCircle2, Bot, Eye } from "lucide-react";

export default function LandingPreview({ landing, chatbot }) {
  const L = landing || {};
  return (
    <div data-testid="landing-preview" className="rounded-xl border border-white/10 overflow-hidden bg-slate-900">
      <div className="px-4 py-2 border-b border-white/10 flex items-center gap-2 text-xs text-slate-400">
        <Eye className="h-3.5 w-3.5" /> Anteprima live della landing
      </div>
      <div className="bg-[#0b1220] p-6 relative overflow-hidden">
        <div className="inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-3 py-1 mb-4">
          <ShieldCheck className="h-3 w-3 text-accent" />
          <span className="text-[11px] font-medium text-accent" data-testid="preview-badge">{L.badge}</span>
        </div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-white leading-tight" data-testid="preview-title">
          {L.titolo} <span className="text-gradient-brand">{L.titolo_evidenziato}</span> {L.titolo_coda}
        </h1>
        <p className="text-sm text-slate-300 mt-3 leading-relaxed">{L.sottotitolo}</p>
        <div className="flex flex-wrap items-center gap-3 mt-4">
          <span className="inline-flex items-center gap-2 bg-accent text-white text-sm font-semibold px-4 py-2 rounded-md">
            {L.cta} <ArrowRight className="h-4 w-4" />
          </span>
          <span className="inline-flex items-center gap-1 text-xs text-slate-300">
            <CheckCircle2 className="h-4 w-4 text-emerald-400" /> {L.cta_nota}
          </span>
        </div>
      </div>
      <div className="p-6 bg-white text-slate-900">
        <h2 className="font-display text-lg font-bold text-center">{L.chat_titolo}</h2>
        <p className="text-xs text-slate-500 text-center mt-1">{L.chat_sottotitolo}</p>
        <div className="mt-4 rounded-xl border border-slate-200 overflow-hidden">
          <div className="flex items-center gap-2 px-3 py-2 border-b border-slate-200 bg-slate-50">
            <div className="h-7 w-7 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center">
              <Bot className="h-4 w-4 text-white" />
            </div>
            <div>
              <div className="text-sm font-semibold" data-testid="preview-assistant-name">{chatbot?.nome_assistente}</div>
              <div className="text-[10px] text-emerald-600">Online · risponde in tempo reale</div>
            </div>
          </div>
          <div className="p-3 bg-slate-50/50">
            <div className="max-w-[90%] rounded-2xl rounded-bl-md bg-white border border-slate-200 px-3 py-2 text-xs leading-relaxed whitespace-pre-wrap">
              {String(chatbot?.saluto || "").replace(/\*\*/g, "")}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-slate-950 px-6 py-3 text-[10px] text-slate-400">{L.footer_testo}</div>
    </div>
  );
}
